/**
 * Implements big trades page placeholder
 */
import Skeleton from 'react-loading-skeleton';

const BigTradesTablePlaceholder = () => {
  return (
    <div className='bigTrades__table'>
      <div className='thead'>
        <Skeleton height={28} />
      </div>
      <div className='tbody'>
        <Skeleton height={40} count={8} />
      </div>
    </div>
  );
};

export default BigTradesTablePlaceholder;
